import axiosGlobal from 'axios';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var noop = (function (value) {
  return value;
});

var isString = function isString(value) {
  return typeof value === 'string';
};

var isFunction = function isFunction(value) {
  return typeof value === 'function';
};

var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};

var isNumber = function isNumber(value) {
  return typeof value === 'number' && !isNaN(value);
};

var isArray = function isArray(value) {
  return Array.isArray(value);
};

var isObject$1 = function isObject(value) {
  return value !== null && !Array.isArray(value) && _typeof(value) === 'object';
};

var isNullOrUndefined = function isNullOrUndefined() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return value === null;
};

var isRegExp = function isRegExp(value) {
  var safeValue = value || '';
  return safeValue.constructor.name === RegExp.name;
};

var isEmpty$1 = function isEmpty() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if (isNullOrUndefined(value)) return true;
  var isValueObject = isObject$1(value);
  var isImpliedValue = isNumber(value) || isFunction(value) || value === true;
  var isEmptyObject = isValueObject && !isRegExp(value) && Object.keys(value).length === 0;
  return isEmptyObject || !isImpliedValue && !isValueObject && !value.length;
};

var check = function check(value) {
  return {
    get isString() {
      return isString(value);
    },

    get isFunction() {
      return isFunction(value);
    },

    get isBoolean() {
      return isBoolean(value);
    },

    get isNumber() {
      return isNumber(value);
    },

    get isArray() {
      return isArray(value);
    },

    get isObject() {
      return isObject$1(value);
    },

    get isNullOrUndefined() {
      return isNullOrUndefined(value);
    },

    get isRegExp() {
      return isRegExp(value);
    },

    get isEmpty() {
      return isEmpty$1(value);
    }

  };
};

check.isString = isString;
check.isFunction = isFunction;
check.isBoolean = isBoolean;
check.isNumber = isNumber;
check.isArray = isArray;
check.isObject = isObject$1;
check.isNullOrUndefined = isNullOrUndefined;
check.isRegExp = isRegExp;
check.isEmpty = isEmpty$1;

var isObject = check.isObject;

var keysToCamelCase = function keysToCamelCase(input) {
  return !isObject(input) ? input : Object.keys(input).reduce(function (output, key) {
    var value = input[key];
    var outputKey = key.replace(/_+(.)?/g, function ($m) {
      var $1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return $1.toUpperCase();
    });
    return Array.isArray(value) && value.some(isObject) ? _objectSpread2(_objectSpread2({}, output), {}, _defineProperty({}, outputKey, value.map(keysToCamelCase))) : _objectSpread2(_objectSpread2({}, output), {}, _defineProperty({}, outputKey, isObject(value) ? keysToCamelCase(value) : value));
  }, {});
};

var isEmpty = check.isEmpty;

var filterEmptyProps = function filterEmptyProps(obj) {
  return Object.keys(obj).reduce(function (cleanObj, key) {
    return isEmpty(obj[key]) ? cleanObj : _objectSpread2(_objectSpread2({}, cleanObj), {}, _defineProperty({}, key, obj[key]));
  }, {});
};

var paramsSerializer = function paramsSerializer(params) {
  return Object.keys(filterEmptyProps(params)).map(function (key) {
    return "".concat(key, "=").concat(params[key]);
  }).join('&');
};

var _excluded$1 = ["url", "params"];
var WP_ENDPOINT = '/beet/v2/';
var defaults = {
  requestConfig: noop,
  axiosConfig: noop,
  normalizeOptions: noop
};
var modes = {
  nova: {
    requestConfig: function requestConfig(url, params) {
      return {
        url: url,
        params: params
      };
    },
    normalizeOptions: function normalizeOptions(options) {
      return options.reduce(function (optionMap, _ref) {
        var key = _ref.key,
            data = _ref.data;
        return _objectSpread2(_objectSpread2({}, optionMap), {}, _defineProperty({}, key, data));
      }, {});
    }
  },
  wp: {
    requestConfig: function requestConfig(url, params) {
      return {
        params: _objectSpread2(_objectSpread2({}, params), {}, {
          rest_route: "".concat(WP_ENDPOINT).concat(url)
        })
      };
    },
    axiosConfig: function axiosConfig(_ref2) {
      var url = _ref2.url,
          params = _ref2.params,
          config = _objectWithoutProperties(_ref2, _excluded$1);

      return _objectSpread2(_objectSpread2({}, config), {}, {
        params: _objectSpread2(_objectSpread2({}, params), {}, {
          rest_route: "".concat(WP_ENDPOINT).concat(url)
        })
      });
    }
  }
};
var modes$1 = (function (apiMode) {
  return _objectSpread2(_objectSpread2({}, defaults), modes[apiMode] || {});
});

var SET = {
  READY: 'beet/SET_READY',
  PAGES: 'beet/SET_PAGES',
  DATA: 'beet/SET_DATA',
  OPTIONS: 'beet/SET_OPTIONS'
};
var UPDATE = {
  PAGES: 'beet/UPDATE_PAGES',
  DATA: 'beet/UPDATE_DATA',
  DATAKEY: 'beet/UPDATE_DATAKEY'
};

var axios = axiosGlobal.create({
  paramsSerializer: paramsSerializer
});
var actionsFactory = (function (apiUrl, apiMode, initialData, defaultLang) {
  var prevLang = undefined;
  var baseURL = apiUrl.replace(/\/$/, '');
  var mode = modes$1(apiMode);

  var fetch = function fetch(path, query) {
    return axios(_objectSpread2({
      baseURL: baseURL
    }, mode.requestConfig(path, query))).then(function (_ref) {
      var data = _ref.data;
      return data;
    });
  };

  var langQuery = function langQuery(lang) {
    return lang === defaultLang ? {} : {
      lang: lang
    };
  };

  return {
    fetchCoreData: function fetchCoreData(_ref2, _ref3) {
      var commit = _ref2.commit;

      var _ref4 = _slicedToArray(_ref3, 2),
          lang = _ref4[0],
          _ref4$ = _ref4[1],
          dataParser = _ref4$ === void 0 ? noop : _ref4$;

      commit(SET.READY, [false]);
      return Promise.all([fetch('data', langQuery(lang)).then(dataParser), fetch('options', langQuery(lang)).then(mode.normalizeOptions)]).then(function (dataset) {
        return dataset.map(keysToCamelCase);
      }).then(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            data = _ref6[0],
            options = _ref6[1];

        commit(SET.DATA, [_objectSpread2(_objectSpread2({}, initialData), data)]);
        commit(SET.OPTIONS, [options]);
        commit(SET.READY, [true]);
      });
    },
    fetchPage: function fetchPage(_ref7, _ref8) {
      var commit = _ref7.commit,
          state = _ref7.state;

      var _ref9 = _slicedToArray(_ref8, 2),
          slug = _ref9[0],
          lang = _ref9[1];

      var shouldClearPages = state.pages[slug] && lang !== prevLang;
      prevLang = lang;
      if (!shouldClearPages && state.pages[slug]) return;
      fetch("pages/".concat(slug), langQuery(lang)).then(function (_ref10) {
        var data = _ref10.data,
            _ref10$seo = _ref10.seo,
            seo = _ref10$seo === void 0 ? {} : _ref10$seo;
        return _objectSpread2({
          seo: seo
        }, data);
      }).then(keysToCamelCase).then(function (page) {
        if (shouldClearPages) commit(SET.PAGES, [{}]);
        commit(UPDATE.PAGES, [_defineProperty({}, slug, page)]);
      });
    },
    fetchData: function fetchData(_ref12, _ref13) {
      var commit = _ref12.commit;

      var _ref14 = _slicedToArray(_ref13, 3),
          dataKey = _ref14[0],
          axiosConfig = _ref14[1],
          _ref14$ = _ref14[2],
          dataParser = _ref14$ === void 0 ? noop : _ref14$;

      return axios(mode.axiosConfig(_objectSpread2({
        baseURL: baseURL
      }, axiosConfig))).then(function (_ref15) {
        var data = _ref15.data;
        return data;
      }).then(keysToCamelCase).then(dataParser).then(function (data) {
        commit(UPDATE.DATA, [_defineProperty({}, dataKey, data)]);
      });
    },
    fetchSingle: function fetchSingle(_ref17, _ref18) {
      var commit = _ref17.commit;

      var _ref19 = _slicedToArray(_ref18, 4),
          dataKey = _ref19[0],
          singleKey = _ref19[1],
          axiosConfig = _ref19[2],
          _ref19$ = _ref19[3],
          dataParser = _ref19$ === void 0 ? noop : _ref19$;

      return axios(mode.axiosConfig(_objectSpread2({
        baseURL: baseURL
      }, axiosConfig))).then(function (_ref20) {
        var data = _ref20.data;
        return dataParser(data);
      }).then(function (data) {
        commit(UPDATE.DATAKEY, [dataKey, _defineProperty({}, singleKey, keysToCamelCase(data))]);
      });
    }
  };
});

var _SET$READY$SET$PAGES$;

var mergeDataObjects = function mergeDataObjects(stateData, newData) {
  return Object.keys(newData).reduce(function (mergedData, dataKey) {
    return _objectSpread2(_objectSpread2({}, mergedData), {}, _defineProperty({}, dataKey, _objectSpread2(_objectSpread2({}, stateData[dataKey]), newData[dataKey])));
  }, stateData);
};

var mutations = (_SET$READY$SET$PAGES$ = {}, _defineProperty(_SET$READY$SET$PAGES$, SET.READY, function (state, _ref) {
  var _ref2 = _slicedToArray(_ref, 1),
      isReady = _ref2[0];

  state.isReady = isReady;
}), _defineProperty(_SET$READY$SET$PAGES$, SET.PAGES, function (state, _ref3) {
  var _ref4 = _slicedToArray(_ref3, 1),
      pages = _ref4[0];

  state.pages = pages;
}), _defineProperty(_SET$READY$SET$PAGES$, SET.DATA, function (state, _ref5) {
  var _ref6 = _slicedToArray(_ref5, 1),
      data = _ref6[0];

  state.data = data;
}), _defineProperty(_SET$READY$SET$PAGES$, SET.OPTIONS, function (state, _ref7) {
  var _ref8 = _slicedToArray(_ref7, 1),
      options = _ref8[0];

  state.options = options;
}), _defineProperty(_SET$READY$SET$PAGES$, UPDATE.PAGES, function (state, _ref9) {
  var _ref10 = _slicedToArray(_ref9, 1),
      pages = _ref10[0];

  state.pages = _objectSpread2(_objectSpread2({}, state.pages), pages);
}), _defineProperty(_SET$READY$SET$PAGES$, UPDATE.DATA, function (state, _ref11) {
  var _ref12 = _slicedToArray(_ref11, 1),
      data = _ref12[0];

  state.data = mergeDataObjects(state.data, data);
}), _defineProperty(_SET$READY$SET$PAGES$, UPDATE.DATAKEY, function (state, _ref13) {
  var _ref14 = _slicedToArray(_ref13, 2),
      dataKey = _ref14[0],
      data = _ref14[1];

  if (!state.data[dataKey]) state.data = _objectSpread2(_objectSpread2({}, state.data), {}, _defineProperty({}, dataKey, {}));
  state.data[dataKey] = mergeDataObjects(state.data[dataKey], data);
}), _SET$READY$SET$PAGES$);

var _excluded = ["data"];
var index = (function (Vue, _ref) {
  var store = _ref.store,
      apiUrl = _ref.apiUrl,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'nova' : _ref$mode,
      _ref$initialData = _ref.initialData,
      initialData = _ref$initialData === void 0 ? {} : _ref$initialData,
      _ref$defaultLang = _ref.defaultLang,
      defaultLang = _ref$defaultLang === void 0 ? null : _ref$defaultLang;
  var beetStore = {
    mutations: mutations,
    actions: actionsFactory(apiUrl, mode, initialData, defaultLang),
    getters: {
      globalBeetState: function globalBeetState(_ref2) {
        var data = _ref2.data,
            state = _objectWithoutProperties(_ref2, _excluded);

        return _objectSpread2(_objectSpread2({}, data), state);
      }
    },
    state: function state() {
      return {
        pages: {},
        data: {},
        options: {},
        isReady: false
      };
    }
  };
  store.registerModule('beet', beetStore);
  Object.defineProperties(Vue.prototype, {
    $beet: {
      get: function get() {
        return _objectSpread2(_objectSpread2({}, store.getters.globalBeetState), {}, {
          fetchCoreData: function fetchCoreData(lang, parseCoreData) {
            return store.dispatch('fetchCoreData', [lang, parseCoreData]);
          }
        });
      }
    }
  });
  Vue.mixin({
    computed: {},
    beforeCreate: function beforeCreate() {
      var beetPage = this.$options.beetPage;
      if (!beetPage) return;

      this.$options.computed.$page = function () {
        return this.$store.state.beet.pages[beetPage] || null;
      };
    },
    created: function created() {
      var _this$$options = this.$options,
          beetPage = _this$$options.beetPage,
          beetLang = _this$$options.beetLang;
      if (!beetPage) return;

      var fetchPage = function fetchPage(lang, oldLang) {
        if (!oldLang || lang !== oldLang) store.dispatch('fetchPage', [beetPage, lang]);
      };

      if (!this.$lang && !beetLang) return fetchPage();
      this.$watch(beetLang || '$lang.current', fetchPage, {
        immediate: true
      });
    }
  });
});

export { index as default };
